import { isProductionStage } from '../utils/environmentMode';

const STORAGE_KEY = 'dashboard.storeDeliveryTypeOverrides';

const shouldUseDeliveryTypeOverrides = () => !isProductionStage();

const readOverrides = () => {
  if (!shouldUseDeliveryTypeOverrides()) {
    return {};
  }

  try {
    const storedValue = window.localStorage.getItem(STORAGE_KEY);

    if (!storedValue) {
      return {};
    }

    const parsedValue = JSON.parse(storedValue);

    return parsedValue && typeof parsedValue === 'object' ? parsedValue : {};
  } catch (error) {
    return {};
  }
};

const writeOverrides = overrides => {
  if (!shouldUseDeliveryTypeOverrides()) {
    return;
  }

  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(overrides || {}));
  } catch (error) {
    return;
  }
};

export const getStoredStoreDeliveryTypeOverride = storeId => {
  if (!storeId || !shouldUseDeliveryTypeOverrides()) {
    return null;
  }

  const overrides = readOverrides();
  const override = overrides[storeId];

  return Array.isArray(override) ? override : null;
};

export const setStoredStoreDeliveryTypeOverride = (storeId, directType) => {
  if (!storeId || !Array.isArray(directType) || !shouldUseDeliveryTypeOverrides()) {
    return;
  }

  const overrides = readOverrides();

  overrides[storeId] = directType;
  writeOverrides(overrides);
};

export const applyStoredStoreDeliveryTypeOverride = store => {
  if (!store || !store.store_id || !shouldUseDeliveryTypeOverrides()) {
    return store;
  }

  const directTypeOverride = getStoredStoreDeliveryTypeOverride(store.store_id);

  if (!directTypeOverride) {
    return store;
  }

  return {
    ...store,
    direct_type: directTypeOverride
  };
};